const dispatch = require("~/store.js").dispatch;

const server = require("~/server.js");

const events = require("./emailFetchEvents.js"); // the events for this dispatcher

const emailFetchDispatchers = {
    FetchEmail(facilityID) {
        dispatch((thunkDispatch) => {
            const loading = events.Loading.New();

            thunkDispatch(loading);

            const url = `facility/${facilityID}/completion-emails`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.Loaded.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.LoadErrored.New(ex);

                    thunkDispatch(errored); 
                }); 
        })
    }

};


module.exports = emailFetchDispatchers; 


// WEBPACK FOOTER //
// ./src/events/emailFetch/emailFetchDispatchers.js